import React from 'react';
import ChecklistElement from './ChecklistElementModel';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import type { SelectChangeEvent } from '@mui/material/Select';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

class DropdownChecklistElement extends ChecklistElement {

    private _options: string[];
    private _defaultValue: string | null;
    private _itemEnableMask: boolean[];
    private _dependentElementId: string | null;
    private _dependencyMapping: string[][];

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number, options: string[], defaultValue: string | null, itemEnableMask: boolean[], dependentElementId: string | null, dependencyMapping: string[][]) {

        super(elementId, name, itemNumber, sortNumber, EditorType.DROPDOWN);
        this._options = options;
        this._defaultValue = defaultValue;
        this._itemEnableMask = itemEnableMask;
        this._dependentElementId = dependentElementId;
        this._dependencyMapping = dependencyMapping;
    }

    public get options(): string[] {
        return this._options;
    }

    public set options(value: string[]) {
        this._options = value;
    }

    public get defaultValue(): string | null {
        return this._defaultValue;
    }

    public set defaultValue(value: string | null) {
        this._defaultValue = value;
    }

    public get itemEnableMask(): boolean[] {
        return this._itemEnableMask;
    }

    public set itemEnableMask(value: boolean[]) {
        this._itemEnableMask = value;
    }

    public get dependentElementId(): string | null {
        return this._dependentElementId;
    }

    public set dependentElementId(value: string | null) {
        this._dependentElementId = value;
    }

    public get dependencyMapping(): string[][] {
        return this._dependencyMapping;
    }

    public set dependencyMapping(value: string[][]) {
        this._dependencyMapping = value;
    }

    public getValueIndexFromValue(value: string | null): number | null {

        const index: number = this.options.findIndex((option: string) => option === value);

        if (index < 0) {
            return null;
        }

        return index;
    }

    public buildFormElement(value: string, onChange: (value: string) => Promise<void>, dependencyValueIndex: number | null, screenWidth: number): JSX.Element {

        const dropdownMenuItems: JSX.Element[] = [];

        const currentlyAvailableOptions: string[] = [];
        
        this.options.forEach((option: string, index: number) => {

            if (!(this.itemEnableMask[index] ?? false)) {
                return;
            }

            if (this.dependentElementId !== null) {

                if (dependencyValueIndex === null || this.dependencyMapping[index] === undefined || ((this.dependencyMapping[index]?.length ?? 0) > 0 && !(this.dependencyMapping[index]?.includes(dependencyValueIndex.toString()) ?? false))) {
                    return;
                }
            }

            currentlyAvailableOptions.push(option);

            dropdownMenuItems.push(
                <MenuItem
                    key={index}
                    value={option}
                >
                    {option}
                </MenuItem>,
            );
        });

        return (
            <React.Fragment key={this.elementId}>
                <FormControl 
                    size='small'
                    style={{
                        width: Math.min(screenWidth * 0.8, 500),
                    }}
                >
                    <InputLabel>{this.name}</InputLabel>
                    <Select
                        value={value}
                        onChange={async (e: SelectChangeEvent): Promise<void> => onChange((e.target as HTMLInputElement).value)}
                        size='small'
                        variant='outlined'
                        label={this.name}
                    >
                        <MenuItem 
                            key='__empty__'
                            value=''
                        >
                            &nbsp;
                        </MenuItem>
                        {value !== '' && !currentlyAvailableOptions.includes(value) && //allows removed options to still be there until changed
                            <MenuItem 
                                key='__current__'
                                value={value}
                                disabled={true}
                            >
                                {value}
                            </MenuItem>
                        }
                        {dropdownMenuItems}
                    </Select>
                </FormControl>
                <br />
                <br />
            </React.Fragment>
        );
    }
}

export default DropdownChecklistElement;